import React from 'react'
import { useNavigate } from 'react-router-dom';
import './Footer.scss'

const Footer = () => {
  const navigate = useNavigate();

  const handleContact = () => {
    navigate('/contact');
  };

  return (
    <div className='footer-page' id='footer'>
      <div className='footer-page-upper'>
        <h2>Let's work together.</h2>
        <div onClick={() => handleContact()}>
          <div className='contact-circle'/>
          <p>SAY HELLO</p>
          <i class="fas fa-sharp fa-solid fa-chevron-right"></i>
        </div>
      </div>
      <div className='footer-page-lower'>
        <p>@HENNING YANG 2023</p>
        <hr/>
          <a href="https://www.instagram.com/henning_0908/"><i class="fab fa-instagram"></i></a>
          <a href="https://www.facebook.com/henning.yang"><i class="fab fa-facebook"></i></a>
          <a href="https://www.linkedin.com/in/珩-楊-41314b254/"><i class="fab fa-linkedin"></i></a>
          <a href="https://github.com/HenningY"><i class="fab fa-github"></i></a>
          <a href="https://www.behance.net/68aeeeeb"><i class="fab fa-behance-square"></i></a>
      </div>
    </div>
  )
}

export default Footer